import { cn } from "@/libs/utils";
import React, { Fragment } from "react";
import { WebViewSkeleton } from "@/components/webview/games/shared/WebViewSkeleton";

const MAX_CARD_LIST_COUNT = 8;

export const GameCardSkeleton = ({ cardWidth }: { cardWidth?: string }) => {
  return (
    <div className={cn("w-fit animate-pulse", cardWidth)}>
      <WebViewSkeleton className="h-[150px] w-[100px] flex-shrink-0 rounded-md" />
      <WebViewSkeleton className="mt-2 h-[16px] w-[100px] rounded bg-neutral-700" />
    </div>
  );
};
export const GamesCardListSkeleton = ({
  cardCount,
  className,
  cardWidth = "w-full",
}: {
  cardCount?: number;
  className?: string;
  cardWidth?: string;
}) => {
  return (
    <div
      className={cn(
        "scrollbar-none flex gap-x-[10px] gap-y-[16px] overflow-x-scroll bg-black px-4",
        className,
      )}
    >
      {Array.from({ length: cardCount || MAX_CARD_LIST_COUNT }).map(
        (_, idx) => (
          <Fragment key={idx}>
            <GameCardSkeleton cardWidth={cardWidth} />
          </Fragment>
        ),
      )}
    </div>
  );
};
